import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/carts', { params });
/* delivery_at is only sent for orders the client was asked to schedule; leaving
   the key out entirely keeps the request identical to before for the rest. */
const submit = (data, deliveryAt) =>
  axios.post('v1/clients/carts', {
    invoice: { parts: data, ...(deliveryAt ? { delivery_at: deliveryAt.toISOString() } : {}) },
  });
const addItems = (items) => axios.put('v1/clients/carts/add', items);
const deleteItems = (items) => axios.put('v1/clients/carts/remove', items);

const CartAPI = {
  fetchAll,
  submit,
  addItems,
  deleteItems,
};

export default CartAPI;
